module.exports = __webpack_public_path__ + "static/media/UYU.d0abf516.svg";